<template>
  <div class="fluid page_content program_guide_list" v-if="permission && permission.version === '5'">

  	<div class="page_heading">
			<div class="col-5 module_heading" role="heading" aria-level="1">
				<span class="program_guide_icon icon-list"></span>
        <span class="program_guide_title pl-2">Program Guide Management</span>
			</div>

			<div class="col-7 btn_container" v-if="!isAdvisor">
        <button class="btn btn-primary" aria-label="upload" :disabled="!permission.programGuidePermission.create" @click="uploadProgramGuideClicked">upload</button>
        <button class="btn btn-primary" aria-label="bulk upload" :disabled="!permission.programGuidePermission.create" @click="bulkUploadProgramGuideClicked">bulk upload</button>
        <button class="btn btn-primary" aria-label="delete all" :disabled="(totalElements === 0) || permission.systemPermission.readOnly || !permission.programGuidePermission.delete" @click.prevent="showDeleteAllConfirm">delete all</button>
        <button type="button" class="btn btn-primary" :disabled="(selected.length === 0)" @click.prevent="showDeleteConfirm" aria-label="delete">delete</button>
    	</div>
  	</div>

		<div class="course-management-section">
      <div class="page_subheading">
        <div class="toolbar-right ui-list-toolbar">
          <select v-model="pageSize" @change="resetPage" aria-label="page size" class="page_size">
            <option v-for="option in sizeOptions" v-bind:value="option">
              {{ option }}
            </option>
          </select>
          <div class="btn_container pagination_sty3">
            <button type="button" :disabled="firstPage" @click="prev" class="btn btn_trans" :title="$t('previousPage')" :aria-label="$t('previousPage')"><span class="ic2_arr_pre3" aria-hidden="true"></span></button>
            <span class="page_count" aria-hidden="true">{{ page + 1 }}</span>
            <button type="button" :disabled="lastPage" @click="next" class="btn btn_trans" :title="$t('nextPage')" :aria-label="$t('nextPage')"><span class="ic2_arr_next3" aria-hidden="true"></span></button>
          </div>
          <div class="search-box-container">
            <input type="text" class="input-search" placeholder="search by name" aria-label="search by name" v-model="searchTitle" v-on:keyup.enter="searchProgramGuides">
            <button type="button" class="btn btn_srh" @click="searchProgramGuides" aria-label="search program guides">
              <span class="ic_srh ic_search" aria-hidden="true"></span>
            </button>
          </div>
        </div>
      </div>

			<div class="course-management-table-container">
				<table v-if="isProgramGuidesLoaded" class="table b-table table-bordered border">
					<thead class="thead-light text-center">
						<tr>
              <th class="first-column">
                <label class="form-checkbox">
                  <input type="checkbox" v-model="selectAll" @click="select" :disabled="(programGuides.length === 0) || permission.systemPermission.readOnly" aria-label="select all program guides">
                  <i class="form-icon"></i>
                </label>
              </th>
							<th class="second-column">Program Guide Name</th>
							<th class="third-column">Type</th>
              <th class="third-column">Status</th>
              <th class="third-column">Enrolled</th>
              <th class="third-column">Withdrawn</th>
              <th class="last-column">Copy Links</th>
						</tr>
					</thead>
					<tbody v-if="programGuides.length > 0">
						<tr v-for="programGuide in programGuides">
							<td class="first-column text-center">
                <label class="form-checkbox">
                    <input type="checkbox" :value="programGuide.uuid" v-model="selected" :disabled="(programGuides.length === 0) || permission.systemPermission.readOnly" aria-label="select program guide">
                    <i class="form-icon"></i>
                </label>
              </td>
              <td class="second-column"> <a href="#" @click.stop.prevent="goToProgramGuideDetail(programGuide)">{{ programGuide.title }}</a></td>
              <td class="third-column prog-type">{{ programGuide.type }}</td>
              <td class="third-column">
                <template v-if="isAdvisor">
                <span v-if="programGuide.deleted">archived</span>
                <span v-else>active</span>
                </template>
                <template v-else>
                <b-btn class="btn btn_lnk lnk_gray" @click="showActivateProgramModal(programGuide)" v-if="programGuide.deleted">archived</b-btn>
                <b-btn class="btn" @click="showArchiveProgramModal(programGuide)" v-else>active</b-btn>
                </template>
              </td>
              <td class="third-column prog-type">{{ programGuide.enrollmentCount }}</td>
              <td class="third-column prog-type">{{ programGuide.withdrawnCount }}</td>
              <td class="last-column">
                <template v-if="programGuide.pricingPlans.length > 0">
                  Buy URL
                  <copy-to-clipboard :text="generateBuyUrl(programGuide)">
                   <b-button class="btn btn_ic" aria-label="Copy Buy URL to clipboard" @click="notifyUrlCopiedMessage('Buy', programGuide)">
                     <span class="ic ic22-copy"></span>
                   </b-button>
                  </copy-to-clipboard>

                  <span class="lnk_separator">|</span>

                  Learn More URL
                  <copy-to-clipboard :text="generateLearnMoreUrl(programGuide)">
                   <b-button class="btn btn_ic" aria-label="Copy Learn More URL to clipboard" @click="notifyUrlCopiedMessage('Learn More', programGuide)">
                     <span class="ic ic22-copy"></span>
                   </b-button>
                  </copy-to-clipboard>
                </template>

              </td>
						</tr>
					</tbody>
					<tbody v-else>
            <tr>
              <td colspan="5" class="no-result" style="text-align: center;">No Results Found</td>
            </tr>
          </tbody>
				</table>
			</div>
		</div>

    <div class="modal__v22_2">
      <b-modal class="" ref="archiveProgramConfirmModal" no-close-on-backdrop no-close-on-esc centered>
        <div style="text-align: center;">
          <h6>Are you sure you want archive "<strong>{{ selectedProgramGuide.title }}</strong>"?</h6>
        </div>
        <div slot="modal-header" class="header-section">
          <div class="hd_txt2">Please Confirm!</div>
          <div class="close_btn_container">
            <button class="btn_close" aria-label="close" @click="closeArchiveProgramModal">
              <span class="ic-close"></span>
            </button>
          </div>
        </div>
        <div slot="modal-footer" class="w-100">
          <b-button @click.stop.prevent="archiveProgramGuideForES(selectedProgramGuide)" class="btn button-primary next float-right mr-2" aria-label="ok"> yes </b-button>
          <b-button @click="closeArchiveProgramModal" class="btn button-primary next float-right mr-2" aria-label="cancel"> no </b-button>
        </div>
      </b-modal>
    </div>

    <div class="modal__v22_2">
      <b-modal class="" ref="activateProgramConfirmModal" no-close-on-backdrop no-close-on-esc centered>
        <div style="text-align: center;">
          <h6>Are you sure you want to activate "<strong>{{ selectedProgramGuide.title }}</strong>"?</h6>
        </div>
        <div slot="modal-header" class="header-section">
          <div class="hd_txt2">Please Confirm!</div>
          <div class="close_btn_container">
            <button class="btn_close" aria-label="close" @click="closeActivateProgramModal">
              <span class="ic-close"></span>
            </button>
          </div>
        </div>
        <div slot="modal-footer" class="w-100">
          <b-button @click="unarchiveProgramGuideForES(selectedProgramGuide)" class="btn button-primary next float-right mr-2" aria-label="ok"> yes </b-button>
          <b-button @click="closeActivateProgramModal" class="btn button-primary next float-right mr-2" aria-label="cancel"> no </b-button>
        </div>
      </b-modal>
    </div>

    <div class="modal__v22_2">
      <b-modal class="" ref="deleteConfirmModal" no-close-on-backdrop no-close-on-esc centered>
        <div style="text-align: center;">
          <h6>Are you sure you want delete these ({{ selected.length }}) Program Guides?</h6>
        </div>
        <div slot="modal-header" class="header-section">
          <div class="hd_txt2">Please Confirm!</div>
          <div class="close_btn_container">
            <button class="btn_close" aria-label="close" @click="cancelDelete">
              <span class="ic-close"></span>
            </button>
          </div>
        </div>
        <div slot="modal-footer" class="w-100">
          <b-button @click="deleteSelected" class="btn button-primary next float-right mr-2" aria-label="ok"> yes </b-button>
          <b-button @click="cancelDelete" class="btn button-primary next float-right mr-2" aria-label="cancel"> no </b-button>
        </div>
      </b-modal>
    </div>

    <div class="modal__v22_2">
      <b-modal class="" ref="deleteAllConfirmModal" no-close-on-backdrop no-close-on-esc centered>
        <div style="text-align: center;">
          <h6>Are you sure you want delete all ({{totalElements}}) Program Guides?</h6>
        </div>
        <div slot="modal-header" class="header-section">
          <div class="hd_txt2">Please Confirm!</div>
          <div class="close_btn_container">
            <button class="btn_close" aria-label="close" @click="cancelDeleteAll">
              <span class="ic-close"></span>
            </button>
          </div>
        </div>
        <div slot="modal-footer" class="w-100">
          <b-button @click="deleteAllProgramGuides" class="btn button-primary next float-right mr-2" aria-label="ok"> yes </b-button>
          <b-button @click="cancelDeleteAll" class="btn button-primary next float-right mr-2" aria-label="cancel"> no </b-button>
        </div>
      </b-modal>
    </div>

    <div class="loading-spinner">
      <b-modal style="padding: 0px; overflow: hidden;" ref="loadingModal" ok-disabled cancel-diasbled hide-header hide-footer no-close-on-backdrop no-close-on-esc size="sm" centered>
        <div class="text-center" style="color: #FFF; overflow: hidden;">
          <i class="fa fa-spinner fa-3x fa-fw fa-pulse"></i>
        </div>
      </b-modal>
    </div>

  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import '../../../assets/module/css/course/courseList.min.css'
import CopyToClipboard from 'vue-copy-to-clipboard'

export default {
  name: 'program-guide-list',
  components: {
    CopyToClipboard
  },
  data () {
    return {
      pageSize: 10,
      sizeOptions: [ 10, 50, 100 ],
      firstPage: true,
      lastPage: true,
      page: 0,
      totalPages: 0,
      totalElements: 0,
      programGuides: [],
      purchasedPrograms: [],
      isProgramGuidesLoaded: false,
      programGuideDeleteMessage: '',
      programGuideToBeDeleted: {},
      searchTitle: '',
      selected: [],
      selectAll: false,
      copyText: 'url is copied',
      selectedProgramGuide: ''
    }
  },

  mounted () {
    this.loadPermission().then(res => {
      this.$refs.loadingModal.show()
      this.purchasedPrograms = this.loadAllPurchasePrograms()
      setTimeout(() => {
        this.loadProgramGuideList()
      }, 500)
    })
  },
  methods: {
    ...mapActions([
      'loadProgramGuides',
      'deleteProgramGuides',
      'archiveProgramGuide',
      'unarchiveProgramGuide',
      'bulkDeleteProgramGuide',
      'loadAllPurchasePrograms',
      'loadPermission'
    ]),
    loadProgramGuideList () {
      this.loadProgramGuides({page: this.page, count: this.pageSize, title: this.searchTitle}).then(result => {
        this.programGuides = result.content
        this.page = result.number
        this.firstPage = result.first
        this.lastPage = result.last
        this.totalPages = result.totalPages
        this.totalElements = result.totalElements
        this.isProgramGuidesLoaded = true
        this.$refs.loadingModal.hide()
        if (this.selectAll) {
          this.selected = []
          this.selectAll = false
        }
      })
    },
    handleCopy (result) {
      console.log('onCopy', result)
    },
    select () {
      this.selected = []
      if (!this.selectAll) {
        for (var i in this.programGuides) {
          this.selected.push(this.programGuides[i].uuid)
        }
      }
    },
    showDeleteConfirm () {
      if (this.selected.length > 0) {
        this.$refs.deleteConfirmModal.show()
      }
    },
    deleteSelected () {
      this.$refs.deleteConfirmModal.hide()
      this.$refs.loadingModal.show()
      this.deleteProgramGuides(this.selected).then(res => {
        if (res) {
          if (res.succeeded > 0) {
            let message = '' + res.succeeded + ' Program Guide(s) deleted successfully.'
            setTimeout(() => {
              this.$notify({
                group: 'notify',
                type: 'success',
                title: '',
                text: message
              })
            }, 0)
          }
          if (res.unauthorized > 0) {
            let message = '' + res.unauthorized + ' Program Guide(s) not deleted due to lack of permission.'
            setTimeout(() => {
              this.$notify({
                group: 'notify',
                type: 'warn',
                title: '',
                text: message
              })
            }, 500)
          }
        } else {
          this.$notify({
            group: 'notify',
            type: 'error',
            title: '',
            text: 'Program Guide deletion failed due to a network issue.'
          })
        }
        setTimeout(() => {
          this.loadProgramGuideList()
        }, 1000)
      })
      this.selected = []
      this.selectAll = false
    },
    showArchiveProgramModal (program) {
      this.selectedProgramGuide = program
      this.$refs.archiveProgramConfirmModal.show()
    },
    closeArchiveProgramModal () {
      this.$refs.archiveProgramConfirmModal.hide()
      this.selectedProgramGuide = ''
    },
    showActivateProgramModal (program) {
      this.selectedProgramGuide = program
      this.$refs.activateProgramConfirmModal.show()
    },
    closeActivateProgramModal () {
      this.$refs.activateProgramConfirmModal.hide()
      this.selectedProgramGuide = ''
    },
    cancelDelete () {
      this.$refs.deleteConfirmModal.hide()
      this.selected = []
      this.selectAll = false
    },
    showDeleteAllConfirm () {
      this.$refs.deleteAllConfirmModal.show()
    },
    cancelDeleteAll () {
      this.$refs.deleteAllConfirmModal.hide()
    },
    deleteAllProgramGuides () {
      this.$refs.deleteAllConfirmModal.hide()
      this.$refs.loadingModal.show()
      this.bulkDeleteProgramGuide().then(resp => {
        if (resp) {
          this.$notify({
            group: 'notify',
            type: 'success',
            title: '',
            text: 'Successfully deleted all the Program Guides'
          })
        }
        this.loadProgramGuideList()
      })
    },
    bulkUploadProgramGuideClicked () {
      return this.$router.push({name: 'programGuideBulkUpload'})
    },
    uploadProgramGuideClicked () {
      return this.$router.push({name: 'programGuideUpload'})
    },
    archiveProgramGuideForES (programGuide) {
      this.closeArchiveProgramModal ()
      this.archiveProgramGuide(programGuide.uuid).then(resp => {
        if (resp) {
          this.$notify({
            group: 'notify',
            type: 'success',
            title: '',
            text: 'Successfully archive Program.'
          })
        }
        this.loadProgramGuideList()
      })
    },
    unarchiveProgramGuideForES (programGuide) {
      this.closeActivateProgramModal ()
      this.unarchiveProgramGuide(programGuide.uuid).then(resp => {
        if (resp) {
          this.$notify({
            group: 'notify',
            type: 'success',
            title: '',
            text: 'Successfully activated Program.'
          })
        }
        this.loadProgramGuideList()
      })
    },
    alreadyPurchased (programGuide){
        let purchased = false
        this.purchasedPrograms.forEach(uuid => {
        if (uuid === 'ALL' || uuid === programGuide.uuid) {
          purchased = true
        }
      })
      return purchased
    },
    goToProgramGuideDetail (programGuide) {
      if (!programGuide.cipCode) {
        return this.$notify({
          group: 'notify',
          type: 'warn',
          title: '',
          text: 'The selected Program Guide has no associated cip code. Unable to render page.'
        })
      }
      let routerParams = { cipCode: programGuide.cipCode, programGuideCode: programGuide.code, type: programGuide.type, returnTo: 'programGuideList' }
      return this.$router.push({ name: 'programGuideIntroduction', params: routerParams })
    },
    searchProgramGuides () {
      this.page = 0
      this.loadProgramGuideList()
    },
    resetPage () {
      this.page = 0
      this.loadProgramGuideList()
    },
    prev () {
      this.page = this.page - 1
      this.loadProgramGuideList()
    },
    next () {
      this.page = this.page + 1
      this.loadProgramGuideList()
    },
    generateBuyUrl (programGuide) {
      let url = window.location.protocol + '//' + window.location.host + '/vue/#/buy?orgId=' + programGuide.institutionId + '&cipCode=' + programGuide.cipCode + '&code=' + programGuide.code + '&type=' + programGuide.type
      return url
    },
    copyBuyUrl(programGuide) {
      $('#' + programGuide.uuid).select()
      document.execCommand('copy')
    },
    generateLearnMoreUrl (programGuide) {
      let learnMoreUrl = window.location.host + '/vue/#/learnMore?orgId=' + programGuide.institutionId + '&cipCode=' + programGuide.cipCode + '&code=' + programGuide.code+'&type=' + programGuide.type
      return learnMoreUrl
    },
    notifyUrlCopiedMessage (messageType, programGuide) {
      setTimeout(() => {
        this.$notify({
          group: 'notify',
          type: 'success',
          title: '',
          text: messageType + ' Url is copied for ' + programGuide.title
        })
      }, 0)
    }
  },
  computed: {
    ...mapState({
      'permission': state => state.user.permission
    }),
    isAdvisor: function () {
        return (localStorage.getItem('userrole') === 'Advisor')
    }

  }
}
</script>

<style scoped>
.program_guide_icon {
  float:left;
  width:30px;
  font-size:30px;
  color:#34b2ff;
  margin:3px 3px 0 0 !important;
}

.program_guide_title {
  color: #34b2ff;
  font-size: 22px;
  font-weight: 400;
  float: left;
  margin-top: 4px;
}
.btn_ic {
  padding: 0 4px;
}
</style>



// WEBPACK FOOTER //
// src/app/programguide/components/ProgramGuideList.vue